export default __webpack_public_path__ + "static/media/GoogleLogo.ca32b107.svg";